import React, { useState } from 'react';

const formatCurrency = value => {
    if (!value || isNaN(value)) return '0 €';
    return parseFloat(value).toLocaleString('es-ES', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 2 
    }) + ' €';
};

const BasicInfo = ({ costeReforma, costesExtra, onShowCostesExtra, onCargarCostesVacacional, costesVacacional }) => {
    const [loadingCostes, setLoadingCostes] = useState(false);

    const handleCostesExtraClick = async () => {
        if (costesVacacional?.costes) {
            // If we already have the data, just show the modal
            onShowCostesExtra();
        } else if (onCargarCostesVacacional) {
            // If we don't have the data, load it first
            setLoadingCostes(true);
            try {
                const result = await onCargarCostesVacacional();
                
                if (result) {
                    onShowCostesExtra();
                }
            } catch (error) {
                console.error('❌ BasicInfo - Error loading costes extra:', error);
            } finally {
                setLoadingCostes(false);
            }
        }
    };

    return (
        <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-50 p-3 rounded">
                <span className="text-sm text-gray-600">Coste Reforma:</span>
                <div className="font-bold text-lg">{formatCurrency(costeReforma)}</div>
            </div>
            {costesExtra > 0 && (
                <div 
                    className="bg-purple-50 p-3 rounded cursor-pointer hover:bg-purple-100 transition-colors"
                    onClick={handleCostesExtraClick}
                >
                    <span className="text-sm text-gray-600">Costes Extra:</span>
                    <div className="font-bold text-lg text-purple-700">{formatCurrency(costesExtra)}</div>
                    <div className="text-xs text-purple-500 mt-1">
                        {loadingCostes ? 'Cargando...' : 'Click para ver detalles'}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BasicInfo; 